import './Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import io from 'socket.io-client'
import { TokenService } from '../../../services/token.service';
import { DataName, SensorNodeStatus } from '../../../util/model';
import { actionUpdateLayerData } from '../../../redux/action/layerData';
import ArrayTable from './arraytable/ArrayTable';
import BF from './bf/BF';
import BF3D from './bf3d/BF3D';
import ElementPower from './elementpower/ElementPower';
import GriffinStatus from './griffinstatus/GriffinStatus';
import Likelihood from './likelihood/Likelihood';
import LockTime from './locktime/LockTime';
import PSD from './psd/PSD';
import SNR from './snr/SNR';
import GriffinTemperature from './temperature/GriffinTemperature';
import TrackingStatus from './trackingstatus/TrackingStatus';
import TrackingTable from './trackingtable/TrackingTable';
import UBlox from './ublox/UBlox';
import RelayTitle from './relay/RelayTitle';
import RelayTemperature from './temperature/RelayTemperature';
import RelayStatus from './relay/RelayStatus';


export default function StatusAdmin() {
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    const SNList = layerData.status.SensorNodes;
    
    const [snIndex, setSNIndex] = useState(-1);
    function onSNChange(val: any) {
        if (val.target.value >= 0 && val.target.value < SNList.length) {
            setSNIndex(val.target.value);
        }
    }

    useEffect(() => {
        if (SNList.length > 0) {
            setSNIndex(0);
        } else {
            setSNIndex(-1);
        }
    }, [SNList.length]);
  
    useEffect(() => {
        const socket = io(window.location.host, {
            reconnectionDelayMax: 10000,
            path: '/api/socket',
            withCredentials: true,
            extraHeaders: {
                'Authorization': `Bearer ${TokenService.getToken()}`,
            }
        });
        socket!.emit('join', 'status');  
        socket.connect();
        socket.on('status', (status: SensorNodeStatus) => {
            dispatch(actionUpdateLayerData('status', status) as any)
        });
        socket.on('report', () => {
        });
        socket.on('error', (error) => {
        });
        socket.io.on("reconnect", (attempt) => {
            socket!.emit('join', 'status'); 
        });
        socket.io.on("reconnect_error", (error) => {
        });
        socket.io.on("reconnect_failed", () => {
        });
        return () => {
            socket!.emit('leave', 'status');
        };
console.log('window width', window.innerWidth);
    }, []);
    
    function ThreeColumns() {
        return (
        <div className="Status">
            <div className="status-body">
                <Table>
                    <TableBody><TableRow>
                        <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '30%', backgroundColor: 'black'}}>
                            <Table><TableBody>
                                <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                    <TableCell colSpan={2} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black', color: 'white'}}>
                                        <Select id="sn-name" value={snIndex} onChange={onSNChange} onOpen={onSNChange} style={{backgroundColor: "rgba(200, 200, 200, 1)", color: "black"}}>
                                            {SNList.map((sn, index) => ( <MenuItem value={index}>{sn}</MenuItem>))}
                                        </Select>
                                    </TableCell>
                                </TableRow>
                                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                    <TableCell colSpan={1} style={{ border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} padding="none">
                                        <GriffinStatus index={snIndex}/>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} >
                                        <BF index={snIndex} plotHeight={window.innerWidth * 0.3 * 0.5}/>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} >
                                        <BF3D index={snIndex} plotHeight={window.innerWidth * 0.3 * 0.5}/>
                                    </TableCell>
                                </TableRow>
                            </TableBody></Table>
                        </TableCell>
                        <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '30%', backgroundColor: 'black'}}>
                            <Table><TableBody>
			        <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <PSD index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <TrackingStatus index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <LockTime index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <SNR index={snIndex}/>
                                </TableCell>
                                </TableRow>
			    </TableBody></Table>	
                        </TableCell>
                        <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '40%', backgroundColor: 'black'}}>
                            <Table><TableBody>
			        <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
			           <TableCell style={{ border: '10px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
			                 <RelayTitle index={snIndex}/>
                                        <RelayTemperature index={snIndex}/>
                                        <RelayStatus index={snIndex}/>
                                  </TableCell>
                                  <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <Likelihood index={snIndex}/>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
				    <TableCell style={{ border: '10px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
                                        <GriffinTemperature index={snIndex}/>
                                        <ArrayTable index={snIndex}/>
                                        <UBlox index={snIndex}/>
                                    </TableCell>
                                    <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black', alignSelf: 'center'}}>
                                        <ElementPower index={snIndex}/>
                                    </TableCell>
			        </TableRow>
                                <TableRow>
				    <TableCell colSpan={2} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black', alignSelf: 'center'}}>
                                        <TrackingTable index={snIndex} versionIndex={0}/>
				    </TableCell>
				</TableRow>
			    </TableBody></Table>
                        </TableCell>
                    </TableRow></TableBody>
                </Table>
            </div>
        </div>
	)
    }
    
    function OneColumn() {
        return (
        <div className="Status">
            <div className="status-body">
                <Table>
                    <TableBody>
                            
                                <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                    <TableCell colSpan={2} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black', color: 'white'}}>
                                        <Select id="sn-name" value={snIndex} onChange={onSNChange} onOpen={onSNChange} style={{backgroundColor: "rgba(200, 200, 200, 1)", color: "black"}}>
                                            {SNList.map((sn, index) => ( <MenuItem value={index}>{sn}</MenuItem>))}
                                        </Select>
                                    </TableCell>
                                </TableRow>
                                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                    <TableCell colSpan={1} style={{ border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} padding="none">
                                        <GriffinStatus index={snIndex}/>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} >
                                        <BF index={snIndex} plotHeight={window.innerWidth * 0.5}/>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} >
                                        <BF3D index={snIndex} plotHeight={window.innerWidth * 0.5}/>
                                    </TableCell>
                                </TableRow>
				<TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <PSD index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                <TableCell style={{ border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
			                 <RelayTitle index={snIndex}/>
                                        <RelayTemperature index={snIndex}/>
                                        <RelayStatus index={snIndex}/>
                                  </TableCell>
                                </TableRow>
				<TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <Likelihood index={snIndex}/>
                                </TableCell>
                                </TableRow>
				<TableRow>
				    <TableCell style={{ border: '10px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                        <GriffinTemperature index={snIndex}/>
                                        <ArrayTable index={snIndex}/>
                                        <UBlox index={snIndex}/>
                                    </TableCell>
				</TableRow>
				<TableRow>
                                    <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black', alignSelf: 'center'}}>
                                        <ElementPower index={snIndex}/>
                                    </TableCell>
			        </TableRow>
                                <TableRow style={{ border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <TrackingStatus index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <LockTime index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow>
                                <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}}>
                                    <SNR index={snIndex}/>
                                </TableCell>
                                </TableRow>
                                <TableRow>
				    <TableCell colSpan={2} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black', alignSelf: 'center'}}>
                                        <TrackingTable index={snIndex} versionIndex={1}/>
				    </TableCell>
				</TableRow>
                    </TableBody>
                </Table>
            </div>
        </div>
	)
    }

    if(window.innerWidth > 800) {
        return (ThreeColumns())
    } else {
        return (OneColumn())
    }
}
